<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="5">
        <v-card flat>
          <v-card-title class="justify-center warning mb-3"
            >Register New Branch</v-card-title
          >
          <v-card-text>
            <v-form ref="BranchForm" v-model="valid" class="px-5">
              <!-- Branch information Row -->
              <v-text-field
                outlined
                solo
                validate-on-blur
                :rules="[
                  v => !!v || 'Branch Name is required',
                  checkBranchName,
                ]"
                label="Branch Name"
                v-model.trim="BranchInfo.BranchName"
                :append-icon="NameIcon"
                color="success"
                required
              >
              </v-text-field>
              <v-text-field
                outlined
                solo
                :rules="[v => !!v || 'Branch phone is require']"
                label="Branch Phone"
                v-model.number="BranchInfo.BranchPhone"
                required
                type="number"
              ></v-text-field>
              <v-text-field
                outlined
                solo
                :rules="[v => !!v || 'Manager Name is require']"
                label="Manager Full Name"
                v-model.trim="BranchInfo.BranchAdmin"
                required
              >
              </v-text-field>
              <v-select
                outlined
                solo
                :items="countries"
                :rules="[v => !!v || 'Country is required']"
                label="Country"
                v-model.trim="BranchInfo.country"
                required
              ></v-select>
              <v-text-field
                outlined
                solo
                :rules="[v => !!v || 'City is require']"
                label="City"
                v-model.trim="BranchInfo.City"
                required
              ></v-text-field>
              <v-select
                outlined
                solo
                item-text="Cashcode"
                item-value="Cashcode"
                prepend-inner-icon="fas fa-search-dollar"
                v-model.trim="BranchInfo.CashBase"
                :items="AllCashes"
                :rules="[v => !!v || 'Cash Type is required']"
                label="Cash Basw"
                required
                no-data-text="Refresh the page"
              ></v-select>
              <v-select
                outlined
                solo
                multiple
                chips
                clearable
                item-text="Cashcode"
                return-object
                prepend-inner-icon="fas fa-search-dollar"
                v-model.trim="BranchInfo.branchCash"
                :items="AllCashes"
                :rules="[v => !!v || 'Breanch Cash is required']"
                label="Branch Cashe"
                required
                no-data-text="Refresh the page"
              ></v-select>
            </v-form>
            <div class="flex-grow-1 text-center  red--text">
              <p class="font-weight-bold" v-if="msgError">{{ msgError }}</p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid"
              color="success"
              width="300"
              :loading="clicked"
              @click="OnSaveBranch"
            >
              Register
              <v-icon right>fas fa-content</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    msgError: "",
    clicked: false,
    valid: true,
    countries: ["Somali", "Kenya", "Dubai", "South Afric"],
    AllCashes: [
      {
        Cashcode: "KES",
        CashName: "Kenya Shillings",
        CashSypol: "Ksh",
      },
      {
        Cashcode: "USD",
        CashName: "United States Dollar",
        CashSypol: "$",
      },
      {
        Cashcode: "EAD",
        CashName: "United Arab Emirates dirham",
        CashSypol: "د.إ",
      },
      {
        Cashcode: "EUR",
        CashName: "Euro",
        CashSypol: "€",
      },
      {
        Cashcode: "GBP",
        CashName: "Pound Sterling",
        CashSypol: "£",
      },
      {
        Cashcode: "TRY",
        CashName: "Turkish lira",
        CashSypol: "₺",
      },
      {
        Cashcode: "JPY",
        CashName: "Japanese yen",
        CashSypol: "¥",
      },
      {
        Cashcode: "RMB",
        CashName: "China Yen",
        CashSypol: "¥",
      },
    ],
    BranchInfo: {
      BranchName: "",
      BranchPhone: "",
      BranchAdmin: "",
      branchCash: [],
      country: "",
      City: "",
      CashBase: null,
    },
    existingInfo: {
      BranchName: false,
      UserName: false,
    },
    showPassword: false,
    NameIcon: null,
    UserIcon: null,
  }),
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    checkBranchName(v) {
      if (this.existingInfo.BranchName) {
        this.existingInfo.BranchName = false;
        this.NameIcon = "fas fa-times";
        return `${v} is already taken`;
      } else {
        this.NameIcon = "fas fa-check";
        return true;
      }
    },

    checkUserName(v) {
      if (this.existingInfo.UserName) {
        this.existingInfo.UserName = false;
        this.UserIcon = "fas fa-times";
        return `${v} is already taken`;
      } else {
        this.UserIcon = "fas fa-check";
        return true;
      }
    },
    OnSaveBranch() {
      if (this.$refs.BranchForm.validate()) {
        this.clicked = true;
        this.msgError = "";
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/branches",
            data: this.BranchInfo,
          })
          .then(() => {
            // console.log(result);
            this.clicked = false;
            this.reset();
          })
          .catch(err => {
            this.clicked = false;
            if (err.response.status === 409) {
              console.log(err.response.data);
              this.existingInfo.BranchName = err.response.data.BranchName;
              this.existingInfo.UserName = err.response.data.UserName;
              this.$refs.BranchForm.validate();
            } else {
              this.msgError = err.response.data;
            }
          });

        // console.log(this.CompanyInfo);
        // this.reset();
      }
    },
    reset() {
      this.$refs.BranchForm.reset();
    },
    resetValidation() {
      this.$refs.BranchForm.resetValidation();
    },
  },
};
</script>
